var render = function render(){var _vm=this,_c=_vm._self._c;return _c('autocomplete',{attrs:{"value":_vm.value,"items":_vm.items,"label":_vm.label || _vm.$t('product_categories.category'),"loading":_vm.loading,"clearable":_vm.clearable,"rules":_vm.rules,"item-value":"id","item-text":"path"},on:{"input":function($event){return _vm.$emit('input', $event === undefined ? null : $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }